"use strict";

AquaTechTheme.registerModule('build-your-setup', null, function() {
    AquaTechTheme.CollectionFilter = {};

    AquaTechTheme.BuildYourSetup = {
        $: null,
        $jsDebug: null,
        clipboard: null,
        filterFields: {
            "fit_camera_brand" : "Camera Brand",
            "fit_camera_model" : "Camera Model",
            "sel_housing_type" : "Housing Type",
            "fit_lens_mount" : "Lens Mount",
            "fit_lens_model" : "Lens Model"
        },

        DEBUG: true,

        subsetGroups: {
          'A' : 'Above Water',
          'OU' : 'Over/Under &amp; Underwater'
        },

        hlinePriority: {
          "Pro"  : { "priority": 0, "label": "Pro: Backplate Controls + Shutter and Zoom" },
          "Base" : { "priority": 1, "label": "Base: Shutter and Zoom Control Only" },
          "MAX"  : { "priority": 2, "label": "Max: Backplate Controls + Shutter and Zoom" }
        },

        selectedCameraBrand: null,
        selectedCameraModel: null,
        selectedHousingType: null,
        selectedLensMount: null,
        selectedLensModel: null,

        // keys: product_id or product_id:variant_id
        matchedProductKeys: {},
        matchedHousingProducts: {},
        matchedHousingAccessories: {},
        matchedActionProducts: {},
        matchedOverUnderProducts: {},

        cachedProducts: [],
        cachedCartProducts: [],

        onDocReady: function() {
            this.$ = AquaTechTheme.$;
            var $ = this.$;

            $('.footer-wrapper').removeClass('fix-to-bottom');

            this.initFilter();
        },

        initFilter: function() {
            var $ = this.$;

            this.loadLensPortReferenceTables();
        },

        loadLensPortReferenceTables: function() {
            var self = this;
            CustLoadScript("//aquatech.net/cdn/shop/t/120/assets/AquaTechTheme-collection-filter-PSeriesLensPorts.js?v=72620158067426185331791849987", function() {
              self.loadZoomGearReferenceTables();
            });
        },

        loadZoomGearReferenceTables: function() {
            var self = this;

            AquaTechTheme.CollectionFilter.primaryCFF = AquaTechTheme.CollectionFilter.CustomFilterField;
            AquaTechTheme.CollectionFilter.primaryCFT = AquaTechTheme.CollectionFilter.CustomFilterTable;

            CustLoadScript("//aquatech.net/cdn/shop/t/120/assets/AquaTechTheme-collection-filter-ZoomGears.js?v=142263283602416379451791769357", function() {
              self.onCustomReferenceTablesLoaded();
            });
        },

        onCustomReferenceTablesLoaded: function() {
            var self = this;
            var $ = self.$;

            AquaTechTheme.CollectionFilter.subCustomFilterField = AquaTechTheme.CollectionFilter.CustomFilterField;
            AquaTechTheme.CollectionFilter.subCustomFilterTable = AquaTechTheme.CollectionFilter.CustomFilterTable;
            AquaTechTheme.CollectionFilter.CustomFilterField = AquaTechTheme.CollectionFilter.primaryCFF;
            AquaTechTheme.CollectionFilter.CustomFilterTable = AquaTechTheme.CollectionFilter.primaryCFT;
            delete AquaTechTheme.CollectionFilter.primaryCFF;
            delete AquaTechTheme.CollectionFilter.primaryCFT;

            self.loadWaterHousingReferenceTables();
        },

        loadWaterHousingReferenceTables: function() {
            var self = this;

            CustLoadScript("//aquatech.net/cdn/shop/t/120/assets/AquaTechTheme-buildyoursetup-filter-WaterHousings.js?v=69301982970819922661783926805", function() {
              self.onWaterHousingReferenceTablesLoaded();
            });

        },

        onWaterHousingReferenceTablesLoaded: function() {
            var self = this;

            self.constructBrandModelTables();
            self.constructWHAccessoriesTables();
            self.constructModelMountTables();
            self.renderFilterControls();
        },

        renderFilterControls: function() {
            var self = this;
            var $ = self.$;

            var $insertPoint = $('#buildyoursetup-panel');

            var innerEl = $('<div class="collection-metafilters-wrap"></div>');
            $insertPoint.append(innerEl);
            var cmfEl = $('<div id="collection-metafilters"></div>');
            $(innerEl).append(cmfEl);
            var $mFilters = $(cmfEl);

            $mFilters.append('<div class="aq-logo"><img src="//aquatech.net/cdn/shop/t/127/assets/aqlogo-filter.png?v=152285125404487213341732294728" width="109" height="108" /></div>')
            $mFilters.append('<h3 class="prompt">Build Your Setup</h3>');
            var sWrap = $('<div class="filter-stages"></div>');
            $mFilters.append(sWrap);
            var $sWrap = $(sWrap);

            for (var ffname in self.filterFields) {
                if (self.filterFields.hasOwnProperty(ffname)) {
                    var fflabel = self.filterFields[ffname];
                    $sWrap.append('<select name="' + ffname + '"><option value="">' + fflabel + '</option></select>');

                    var $selField = $("select[name='" + ffname + "']");
                    $selField.select2({
                        minimumResultsForSearch: Infinity,
                        templateResult: self.formatTemplateResult,
                        templateSelection: self.formatOptionText
                    }).data('select2').$dropdown.addClass('collection-metafilter-dropdown');

                    /*$selField.on('select2:open', function() {
                        setTimeout(function() {
                            var $results = $('.select2-results');
                            var $firstLi = $results.find('li').first();
                            $firstLi.html('All');
                        }, 1);
                    });*/

                    $selField.on('change', function() {
                        self.setFilterConstraints();
                        self.onFilterStateChange();
                    });
                }
            }

            $insertPoint.append('<div class="product-recommendations-messages"></div>');
            $insertPoint.append('<div class="product-recommendations"></div>');

            self.populateCameraBrandSelect();
            self.populateCameraModelSelect();
            self.populateHousingTypeSelect();
            self.populateLensMountSelect();
            self.setFilterConstraints();
            self.onFilterStateChange();
            self.watchCart();
            self.applyUrl();
        },

        formatTemplateResult: function(item, container) {
            if (item.element) {
              $(container).addClass($(item.element).attr("class"));
            }

            return AquaTechTheme.BuildYourSetup.formatOptionText(item);
        },

        formatOptionText: function(item) {
            // Return the text directly if it is a placeholder or has no ID
            if (!item.id) {
                return item.text;
            }

            // Example logic: Bold everything before the first :
            var boldIfBegin = [ 'Base:', 'Pro:', 'Max:' ];
            var doBold = false;
            for (var bib = 0; bib < boldIfBegin.length; bib++) {
              if (item.text.startsWith(boldIfBegin[bib])) {
                doBold = true;
                break;
              }
            }

            if (doBold) {
              var parts = item.text.split(':');

              if (parts.length > 1) {
                  var boldPart = parts[0].trim();
                  var normalPart = parts.slice(1).join('-').trim();

                  // Construct a jQuery element to safely output HTML
                  return $('<span><strong>' + boldPart + '</strong>: ' + normalPart + '</span>');
              }
            }

            // Fallback if the pattern doesn't match
            return item.text;
        },

        constructBrandModelTables: function() {
            var numOpts = AquaTechTheme.BuildYourSetup.WaterHousingsTable.length;
            AquaTechTheme.BuildYourSetup.CAMERA_MODELS = {};
            AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS = {};
            AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS = {};

            for (var cfo = 0; cfo < numOpts; cfo++) {
              var opt = AquaTechTheme.BuildYourSetup.WaterHousingsTable[cfo];

              if (!AquaTechTheme.BuildYourSetup.CAMERA_MODELS.hasOwnProperty(opt.brand)) {
                  AquaTechTheme.BuildYourSetup.CAMERA_MODELS[opt.brand] = { 'models': [] };
              }
              if (!AquaTechTheme.BuildYourSetup.CAMERA_MODELS[opt.brand].models.includes(opt.model)) {
                  AquaTechTheme.BuildYourSetup.CAMERA_MODELS[opt.brand].models.push(opt.model);
              }

              if (!AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS.hasOwnProperty(opt.model)) {
                  AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS[opt.model] = { 'mounts': [] };
              }
              if (!AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS[opt.model].mounts.includes(opt.mount)) {
                  AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS[opt.model].mounts.push(opt.mount);
              }

              if (!AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS.hasOwnProperty(opt.model)) {
                AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS[opt.model] = [];
              }
              if (!AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS[opt.model].includes(opt.hline)) {
                AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS[opt.model].push(opt.hline);
              }
            }
        },

        constructWHAccessoriesTables: function() {
            var numOpts = AquaTechTheme.BuildYourSetup.WaterHousingAccessoryTable.length;
            AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES = {};

            for (var cfo = 0; cfo < numOpts; cfo++) {
              var opt = AquaTechTheme.BuildYourSetup.WaterHousingAccessoryTable[cfo];

              if (!AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES.hasOwnProperty(opt.subset)) {
                AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES[opt.subset] = [];
              }
              AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES[opt.subset].push(opt);
            }
        },

        constructModelMountTables: function() {
            var numOpts = AquaTechTheme.CollectionFilter.CustomFilterTable.length;
            AquaTechTheme.CollectionFilter.LENS_MOUNTS = {};
            for (var cfo = 0; cfo < numOpts; cfo++) {
                var opt = AquaTechTheme.CollectionFilter.CustomFilterTable[cfo];
                var mountName = opt.parent;
                if (!AquaTechTheme.CollectionFilter.LENS_MOUNTS.hasOwnProperty(mountName)) {
                    AquaTechTheme.CollectionFilter.LENS_MOUNTS[mountName] = { 'models': [] };
                }
                var modelName = opt.label;
                if (!AquaTechTheme.CollectionFilter.LENS_MOUNTS[mountName].models.includes(modelName)) {
                    AquaTechTheme.CollectionFilter.LENS_MOUNTS[mountName].models.push(modelName);
                }
            }
        },

        populateCameraBrandSelect: function() {
            var $ = this.$;

            // Always populated.

            var $selField = $("select[name='fit_camera_brand']");
            $selField.find('option').remove().end().append('<option value="">Camera Brand</option>');

            for (var model in AquaTechTheme.BuildYourSetup.CAMERA_MODELS) {
                if (AquaTechTheme.BuildYourSetup.CAMERA_MODELS.hasOwnProperty(model)) {
                    $selField.append('<option value="' + model + '">' + model + '</option>');
                }
            }
        },

        populateCameraModelSelect: function() {
            var $ = this.$;

            // Requires Camera Brand

            var $selField = $("select[name='fit_camera_model']");
            $selField.find('option').remove().end().append('<option value="">Camera Model</option>');

            var brand = $("select[name='fit_camera_brand']").val();
            if (brand !== '') {
              var modelsInBrand = AquaTechTheme.BuildYourSetup.CAMERA_MODELS[brand].models;
              for (var mi = 0; mi < modelsInBrand.length; mi++) {
                var model = modelsInBrand[mi];
                $selField.append('<option value="' + model + '">' + model + '</option>');
              }
              $selField.prop('disabled', false);

            } else {
              $selField.prop('disabled', 'disabled');
            }
        },

        populateHousingTypeSelect: function() {
            var self = this;
            var $ = this.$;

            // Requires Camera Brand > Model
            var $selField = $("select[name='sel_housing_type']");
            $selField.find('option').remove().end().append('<option value="">Housing Type</option>');

            var brand = $("select[name='fit_camera_brand']").val();
            var model = $("select[name='fit_camera_model']").val();
            if (brand !== '' && model !== '') {
              var housingsInModel = AquaTechTheme.BuildYourSetup.CAMERA_MODEL_HOUSINGS[model];
              var housingOptions = [];
              for (var hi = 0; hi < housingsInModel.length; hi++) {
                var housing = housingsInModel[hi];
                var hSpec = self.hlinePriority[housing];
                if (hSpec) {
                  housingOptions[hSpec.priority] = { "option" : housing, "label" : hSpec.label };
                }
              }
              for (var ho = 0; ho < housingOptions.length; ho++) {
                if (housingOptions[ho]) {
                  $selField.append('<option value="' + housingOptions[ho].option + '">' + housingOptions[ho].label  + '</option>');
                }
              }
              $selField.prop('disabled', false);

            } else {
              $selField.prop('disabled', 'disabled');
            }
        },

        populateLensMountSelect: function() {
            var $ = this.$;

            // Requires Camera Brand > Model > Housing Type

            var $selField = $("select[name='fit_lens_mount']");
            $selField.find('option').remove().end().append('<option value="">Lens Mount</option>');

            var brand = $("select[name='fit_camera_brand']").val();
            var model = $("select[name='fit_camera_model']").val();
            var housing = $("select[name='sel_housing_type']").val();
            if (brand !== '' && model !== '' && housing !== '') {
              var mountsInModel = AquaTechTheme.BuildYourSetup.CAMERA_MOUNTS[model].mounts;
              for (var mi = 0; mi < mountsInModel.length; mi++) {
                var mount = mountsInModel[mi];
                $selField.append('<option value="' + mount + '">' + mount  + '</option>');
              }
              $selField.prop('disabled', false);

            } else {
              $selField.prop('disabled', 'disabled');
            }
        },

        populateLensModelSelect: function() {
            var $ = this.$;

            var $modelSelectField = $("select[name='fit_lens_model']");
            var mountName = $("select[name='fit_lens_mount']").val();
            if (mountName !== '') {
                $modelSelectField.prop('disabled', false);
                var mountModels = AquaTechTheme.CollectionFilter.LENS_MOUNTS[mountName].models;
                for (var model in mountModels) {
                    if (mountModels.hasOwnProperty(model)) {
                        var modelName = mountModels[model];
                        $modelSelectField.append('<option value="' + modelName + '">' + modelName + '</option>');
                    }
                }

            } else {
                $modelSelectField.find('option').remove().end().append('<option value="">Lens Model</option>');
                $modelSelectField.prop('disabled', 'disabled');
            }
        },

        setFilterConstraints: function() {
            var self = this;
            var $ = this.$;

            var selectedCameraBrand = $("select[name='fit_camera_brand']").val();
            var selectedCameraModel = $("select[name='fit_camera_model']").val();
            var selectedHousingType = $("select[name='sel_housing_type']").val();
            var selectedLensMount = $("select[name='fit_lens_mount']").val();
            var selectedLensModel = $("select[name='fit_lens_model']").val();

            var filterChanged = false;

            if (self.selectedCameraBrand !== selectedCameraBrand) {
              self.populateCameraModelSelect();
              self.populateHousingTypeSelect();
              self.populateLensMountSelect();
              self.populateLensModelSelect();
            }

            if (self.selectedCameraModel !== selectedCameraModel) {
              self.populateHousingTypeSelect();
              self.populateLensMountSelect();
              self.populateLensModelSelect();
            }

            if (self.selectedHousingType !== selectedHousingType) {
              self.populateLensMountSelect();
              self.populateLensModelSelect();
            }

            if (self.selectedLensMount !== selectedLensMount) {
              self.populateLensModelSelect();
            }

            self.selectedCameraBrand = selectedCameraBrand;
            self.selectedCameraModel = selectedCameraModel;
            self.selectedHousingType = selectedHousingType;
            self.selectLensMount = selectedLensMount;
            self.selectedLensModel = selectedLensModel;
        },

        onFilterStateChange: function() {
            var self = this;
            var $ = this.$;

            self.locateMatchingCombinations();
            self.removeBookmark();
        },

        locateMatchingCombinations: function() {
            var self = this;
            var $ = this.$;

            self.selectedCameraBrand = $("select[name='fit_camera_brand']").val();
            self.selectedCameraModel = $("select[name='fit_camera_model']").val();
            self.selectedHousingType = $("select[name='sel_housing_type']").val();
            self.selectedLensMount = $("select[name='fit_lens_mount']").val();
            self.selectedLensModel = $("select[name='fit_lens_model']").val();

            self.matchedProductKeys = [];
            self.matchedHousingProducts = {};
            self.matchedActionProducts = {};
            self.matchedOverUnderProducts = {};

            if (self.selectedCameraBrand !== '' && self.selectedCameraModel !== '' && self.selectedHousingType !== ''
                  && self.selectedLensMount !== '' && self.selectedLensModel !== '') {
                self.locateHousingTableMatches(AquaTechTheme.BuildYourSetup.WaterHousingsTable); // Water Housings
                self.locateTableMatches(AquaTechTheme.CollectionFilter.CustomFilterTable); // Lens Ports
                self.locateTableMatches(AquaTechTheme.CollectionFilter.subCustomFilterTable); // Zoom Gears
                self.loadProducts();
                self.updateUrl();
            } else {
              var $recommendPanel = $('.product-recommendations');
              $recommendPanel.html('<p class="status">Select your camera configuration...</p>').show();
            }
        },

        locateHousingTableMatches: function(table) {
            var self = this;

            var numOpts = table.length;
            for (var cfo = 0; cfo < numOpts; cfo++) {
                var opt = table[cfo];
                var pvKey = opt.product_id;
                if (pvKey == 0) {
                    continue;
                }
                if (opt.hasOwnProperty('variant_id') && opt['variant_id']) {
                    pvKey += ':' + opt.variant_id;
                }

                if (opt.brand == self.selectedCameraBrand && opt.model == self.selectedCameraModel
                    && opt.mount == self.selectedLensMount && opt.hline == self.selectedHousingType) {
                    if (!self.matchedProductKeys.includes(pvKey)) {
                        self.matchedProductKeys.push(pvKey);
                    }

                    if (!self.matchedHousingProducts[pvKey]) {
                        self.matchedHousingProducts[pvKey] = opt;
                    }
                }
            }
        },

        locateTableMatches: function(table) {
            var self = this;

            var opt, pvKey;

            var selectTitle = self.selectedLensMount + ' ' + self.selectedLensModel;
            var numOpts = table.length;
            for (var cfo = 0; cfo < numOpts; cfo++) {
                opt = table[cfo];
                pvKey = opt.product_id;
                if (pvKey == 0) {
                    continue;
                }
                if (opt.hasOwnProperty('variant_id') && opt['variant_id']) {
                    pvKey += ':' + opt.variant_id;
                }
                var rowTitle = opt.parent + ' ' + opt.label;
                if (rowTitle == selectTitle) {
                    if (!self.matchedProductKeys.includes(pvKey)) {
                        self.matchedProductKeys.push(pvKey);
                    }
                    if (opt.hasOwnProperty('subset')) {
                        switch (opt.subset) {
                            case 'A':
                                if (!self.matchedActionProducts[pvKey]) {
                                    self.matchedActionProducts[pvKey] = opt;
                                }
                            break;

                            case 'OU':
                                if (!self.matchedOverUnderProducts[pvKey]) {
                                    self.matchedOverUnderProducts[pvKey] = opt;
                                }
                            break;
                        }
                    } else {
                        if (!self.matchedActionProducts[pvKey]) {
                            self.matchedActionProducts[pvKey] = opt;
                        }
                        if (!self.matchedOverUnderProducts[pvKey]) {
                            self.matchedOverUnderProducts[pvKey] = opt;
                        }
                    }
                }
            }

            // Insert Housing A, OU accesories:

            var oi, oList, oLen;

            oList = AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES['A'];
            oLen = oList.length;
            for (oi = 0; oi < oLen; oi++) {
              opt = oList[oi];
              pvKey = opt.product_id;
              if (pvKey == 0) {
                  continue;
              }
              if (opt.hasOwnProperty('variant_id') && opt['variant_id']) {
                  pvKey += ':' + opt.variant_id;
              }
              if (!self.matchedProductKeys.includes(pvKey)) {
                self.matchedProductKeys.push(pvKey);
              }
              if (!self.matchedActionProducts[pvKey]) {
                self.matchedActionProducts[pvKey] = opt;
              }
            }

            oList = AquaTechTheme.BuildYourSetup.HOUSING_ACCESSORIES['OU'];
            oLen = oList.length;
            for (oi = 0; oi < oLen; oi++) {
              opt = oList[oi];
              pvKey = opt.product_id;
              if (pvKey == 0) {
                  continue;
              }
              if (opt.hasOwnProperty('variant_id') && opt['variant_id']) {
                  pvKey += ':' + opt.variant_id;
              }
              if (!self.matchedProductKeys.includes(pvKey)) {
                self.matchedProductKeys.push(pvKey);
              }
              if (!self.matchedOverUnderProducts[pvKey]) {
                self.matchedOverUnderProducts[pvKey] = opt;
              }
            }
        },

        loadProducts: function() {
            var self = this;

            var $recommendPanel = $('.product-recommendations');
            $recommendPanel.html('<p class="status"><span class="msg">Loading product configurations </span>' + self.ajaxLoaderImgHtml() + '</p>').show();

            self.loadNextRecommendation();
        },

        ajaxLoaderImgHtml: function() {
          return '<img class="loader" src="//aquatech.net/cdn/shop/t/120/assets/ajax-loader.gif?v=344831891803776881716334431)" alt="..." width="16" height="16" />';
        },

        getProductData: function(productId) {
            var self = this;
            var $ = self.$;

            console.log('Fetch ' + productId + '...');

            if (self.cachedProducts[productId] && self.cachedProducts[productId] !== 'fail') {
                self.onRecommendationLoaded();
                return;
            }

            $.ajax({
                url: "/search/suggest.json?q=id:" + productId + "&resources[type]=product&limit=1&resources[options][unavailable_products]=show",
                type: 'GET',
                success: function(response) {
                    self.onProductDataGet(response);
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    self.cachedProducts[productId] = 'fail';
                    console.log(xhr.status + ' ' + thrownError);
                }
            });
        },

        /* Product initial date get, Ajax fetch the rest */
        onProductDataGet: function(response) {
            var self = this;

            var results = response.resources.results.products;
            var product = results[0];

            if (!product) {
                self.showProductError('Could not find matching product(s)');
                return;
            }

            var url = product.url;
            var parts = url.split('?');
            product.slug = parts[0].replace('/products/', '');

            self.cachedProducts[product.id] = product;

            $.ajax({
                url: "/products/" + product.slug + ".json",
                type: 'GET',
                success: function(response2) {
                    self.onProductFullDataGet(response2);
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    self.cachedProducts[productId] = 'fail';
                    console.log(xhr.status + ' ' + thrownError);
                }
            });
        },

        showProductError: function(message) {
            var self = this;
            var $ = self.$;

            var $recommendPanel = $('.product-recommendations');
            $recommendPanel.html('<p class="error">' + message + '</p>').show();
        },

        /* Product rest of data fetched, store variant */
        onProductFullDataGet: function(response) {
            var self = this;

            var product = response.product;
            var firstVariant = response.product.variants[0].id;
            self.cachedProducts[product.id].default_variant_id = firstVariant;
            self.cachedProducts[product.id].variantdata = product.variants;

            self.onRecommendationLoaded();
        },

        /* On recommendation load, load another */
        onRecommendationLoaded: function() {
          var self = this;

          self.loadNextRecommendation();
        },

        /* Load the next uncached recommended product */
        loadNextRecommendation: function() {
            var self = this;
            var $ = self.$;

            for (var pi = 0; pi < self.matchedProductKeys.length; pi++) {
                var pvKey = self.matchedProductKeys[pi];
                var productId = pvKey.split(':')[0];
                if (!self.cachedProducts[productId]) {
                    self.getProductData(productId);
                    return;
                }
            }

            // All loaded, show:

            var $recommendPanel = $('.product-recommendations');
            $recommendPanel.html('');

            self.renderRecommendations('Over');
            self.renderRecommendations('Under');
            self.updateRecommendedTotals();
        },

        /* Output fetched products into display */
        renderRecommendations: function(subtypeSelection) {
            var self = this;
            var $ = self.$;

            // Housing for both:
            var productsToRecommend = {};
            for (var pvhKey in self.matchedHousingProducts) {
                if (self.matchedHousingProducts.hasOwnProperty(pvhKey)) {
                  productsToRecommend[pvhKey] = self.matchedHousingProducts[pvhKey];
                }
            }

            // Plus Set-specific:
            var setTitle = '';
            var subTypeClass = '';
            var introText = '';
            var productsToRecommendAddn = {};
            switch (subtypeSelection) {
                case 'Over':
                    productsToRecommendAddn = self.matchedActionProducts;
                    setTitle = 'Action Kit';
                    subTypeClass = 'st-over-kit';
                    introText = '<p>Typically flat ports (<strong>XF-55 or XLF-75</strong>), are recommended to make managing water droplets easier due to the smaller surface area of these ports.'
                      + 'Whilst still able to be used underwater, the above water recommendations are best suited for photographic requirements when shooting at or above the water\'s surface.</p>';
                    break;
                case 'Under':
                    productsToRecommendAddn = self.matchedOverUnderProducts;
                    setTitle = 'Over/Under Kit';
                    subTypeClass = 'st-under-kit';
                    introText = '<p>Due to the way light properties work underwater, dome ports (<strong>XLD-135, XD-65, or XLD-12</strong>) are typically recommended for wide angle lenses in order to achieve the best image quality.'
                      + 'These ports can also be used above water as well as for capturing Over/Under style image compositions.'
                      + 'Dome ports can be paired with adapters to achieve the most desirable distance between the lens element and the dome port element.</p>';
                    break;
                default:
            }
            for (var pvaKey in productsToRecommendAddn) {
                if (productsToRecommendAddn.hasOwnProperty(pvaKey)) {
                  productsToRecommend[pvaKey] = productsToRecommendAddn[pvaKey];
                }
            }

            var $recommendPanel = $('.product-recommendations');

            var $subTypePanel = $('<div class="subtype-panel ' + subTypeClass + '"></div>');
            $recommendPanel.append($subTypePanel);

            var $title = $('<div class="product-recommend-title">' + setTitle + '</div>');
            $subTypePanel.append($title);

            var $prPanel = $('<div class="product-recommend-panel"></div>');
            $subTypePanel.append($prPanel);

            var $bundleTitle = $('<div class="bundle-title">Housing, Lens Port, Adapter, and Zoom Gear</div>');
            $prPanel.append($bundleTitle);

            var $bundle = $('<div class="product-recommend-bundle"></div>');
            $prPanel.append($bundle);

            var numProds = 0;

            var requirementsToLocate = [ 'water-housing', 'lens-port' ];

            for (var pvKey in productsToRecommend) {
                if (productsToRecommend.hasOwnProperty(pvKey)) {
                    numProds++;
                    var productSpec = productsToRecommend[pvKey];

                    var reqIndex = requirementsToLocate.indexOf(productSpec.type);
                    if (reqIndex > -1) {
                      requirementsToLocate.splice(reqIndex, 1);
                    }

                    var productData = self.cachedProducts[productSpec.product_id];
                    var productHtml = self.recommendedProductHtml(productSpec, productData);
                    var $productPanel = $(productHtml);

                    var $addToCart = $productPanel.find('.add-to-cart .button');
                    $addToCart.on('click', function(e) {
                        e.preventDefault();
                        self.addToCartSingle($(this));
                    });

                    var $selectToggle = $productPanel.find('.select-toggle');
                    $selectToggle.on('click', function(e) {
                        e.preventDefault();
                        var $selectedProductPanel = $(this).closest('.recommend-product.recommended');
                        self.toggleRecommendSelect($selectedProductPanel);
                    });

                    $bundle.append($productPanel);
                }
            }

            var housingToPick = '';
            var $hProds = $bundle.find('.recommend-product.product-housing');
            $hProds.each(function() {
              var $rp = $(this);
              var hline = $rp.attr('data-housing-line');
              switch (hline) {
                case 'Base':
                  housingToPick = 'Base';
                  break;
                case 'Pro':
                  housingToPick !== 'Base' ? 'Pro' : housingToPick;
                  break;
                case 'MAX':
                  housingToPick !== 'Base' && housingToPick !== 'Pro' ? 'MAX' : housingToPick;
                  break;
                default:
              }
            });
            if (housingToPick) {
              $hProds.each(function() {
                var $rp = $(this);
                var hline = $rp.attr('data-housing-line');
                if (hline !== housingToPick) {
                  $rp.attr('data-selected', '');
                  $rp.find('.select-toggle').removeClass('selected');
                }
              });
            }

            if (requirementsToLocate.length > 0) {
              // We did not match enough requirements.
              $subTypePanel.addClass('incomplete-requirements');
              $subTypePanel.find('.product-recommend-bundle').hide();
              $subTypePanel.append('<p class="text-center"><em>Not available in this configuration.</em></p>');
            }

            if (numProds == 0) {
              $subTypePanel.hide();
            }

            if (numProds > 0 && requirementsToLocate.length == 0) {
              $bundleTitle.after('<div class="subtype-intro">' + introText + '</div>');
            }

            var $totalPanel = $(self.totalProductsHtml());
            $bundle.append($totalPanel);
            var $addSelectedButton = $totalPanel.find('.add-to-cart .button');
            $addSelectedButton.on('click', function(e) {
                e.preventDefault();
                self.addToCartSelected($(this));
            });

            var $selectToggle = $totalPanel.find('.select-toggle');
            $selectToggle.on('click', function(e) {
                e.preventDefault();
                self.toggleSelectAll($(this));
            });

            $recommendPanel.addClass('visible');

            self.updateRecommendationsCartState();

            var randDelay = Math.floor(Math.random() * (300 - 100 + 1)) + 100;;
            setTimeout(function() {
              self.applyCurrentSelectionBookmark();
            }, randDelay);
        },

        /* Wipe and hide recommendations panel */
        clearRecommendations: function() {
            var self = this;
            var $ = self.$;

            var $recommendPanel = $('.product-recommendations');
            $recommendPanel.html('');
            $recommendPanel.removeClass('visible');
        },

        /* HTML for recommended product panel */
        recommendedProductHtml: function(productSpec, productData) {
          var self = this;

          var imgSrc = productData.image;
          imgSrc = imgSrc.replace('.jpg', '_550x.jpg');
          imgSrc = imgSrc.replace('.jpeg', '_550x.jpeg');
          imgSrc = imgSrc.replace('.png', '_550x.png');

          var title = productData.title;

          var productId = productData.id;
          var url = productData.url;
          var variantId = (productSpec.variant_id && productSpec.variant_id !== productSpec.product_id) ? productSpec.variant_id : productData.default_variant_id;
          var itemType = productSpec.type;

          var variant = self.findProductVariant(productData, variantId);
          var variantTitle = self.productVariantName(productData, variantId);
          var variantTitleStr = variantTitle ? '<span class="variant-title">' + variantTitle + '</span>' : '';
          var variantPrice = variant.price;

          var available = productData.available;

          var price = parseFloat(variantPrice);
          price = (Math.round(price * 100) / 100).toFixed(2);
          var caPrice = parseFloat(productData.compare_at_price_max);
          caPrice = (Math.round(caPrice * 100) / 100).toFixed(2);
          var priceDisplay = '<span class="money">$' + price + '</span>';
          if (caPrice > price) {
            priceDisplay = '<span class="money price-line-through sale-price">$' + caPrice + '</span>' +
                           priceDisplay;
          }

          var addToCartHtml = '<div class="add-to-cart"><a class="button">Add to cart</a></div>';
          var toggleSelect = '<a class="select-toggle selected">' + self.tickSvg + '</a>';
          var dataSelected = ' data-selected="selected"';
          if (!available) {
            addToCartHtml = '<div class="add-to-cart out-of-stock"><span class="button disabled">Out of Stock</span></div>';
            toggleSelect = '';
            dataSelected = ' data-selected=""';
          }

          var option = '';
          if (productSpec.is_alt_to) {
            option = 'Alternative for ' + productSpec.is_alt_to;
            dataSelected = ' data-selected=""';
            toggleSelect = '<a class="select-toggle">' + self.tickSvg + '</a>';
          }

          var addnClasses = '';
          var dataLine = '';
          if (productSpec.hline) {
            addnClasses = 'product-housing'
            dataLine = ' data-housing-line="' + productSpec.hline + '"';
          }

          var order = 0; // This is redundant now...
          if (productSpec.hline) {
            switch (productSpec.hline) {
              case 'Base':
                order = -3;
              break;
              case 'Pro':
                order = -2;
              break;
              case 'MAX':
                order = -1;
              break;
              default:
                order = 0;
              break;
            }
          }

          var html =
            '<div style="order: ' + order + '" class="recommend-product recommended ' + addnClasses + '" data-itemtype="' + itemType + '" data-product-id="' + productId + '" data-variant-id="' + variantId + '" data-base-price="' + price + '" data-price="' + variantPrice + '" data-available="' + available + '"' + dataLine + dataSelected + '><div class="inner">' +
              '<div class="image"><a href="' + url + '"><img src="' + imgSrc + '" width="550" /></a></div>' +
              '<div class="detail">' +
                '<div class="option">' + option + '</div>' +
                '<div class="title">' +
                  '<span class="product-title">' + title + '</span>' +
                  variantTitleStr +
                '</div>' +
                '<div class="price">' + priceDisplay + '</div>' +
              '</div>' +
              addToCartHtml +
              toggleSelect +
              '<span class="error" style="display: none;">Out of Stock</span>' +
            '</div></div>';

          return html;
        },

        /* Locate variant title in product variant data */
        productVariantName: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId && variant.title !== 'Default Title') {
              return variant.title;
            }
          }

          return null;
        },

        productVariantPrice: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId) {
              return variant.price;
            }
          }

          return null;
        },

        findProductVariant: function(productData, variantId) {
          var variants = productData.variantdata;
          for (var vi = 0; vi < variants.length; vi++) {
            var variant = variants[vi];
            if (variant.id == variantId) {
              return variant;
            }
          }

          return null;
        },

        /* HTML for recommendatons total panel */
        totalProductsHtml: function() {
          var self = this;

          var html =
            '<div class="recommend-product totals"><div class="inner">' +
              '<div class="total">' +
              '<div class="label">Total Price</div>' +
              '<div class="price">$XXX.XX</div>' +
              '</div>' +
              '<div class="add-to-cart"><a class="button">Add selected to cart</a></div>' +
              '<a class="select-toggle">' + self.tickSvg + '</a>' +
            '</div></div>';

          return html;
        },

        /* Checkmark symbol */
        tickSvg: '<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30"> <path d="M5.5 13L9.5 17L19.5 7" stroke="#1077f1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg>',

        toggleRecommendSelect: function($productPanel, setState) {
          var self = this;
          var $ = self.$;

          var state = $productPanel.attr('data-selected');
          var $stateToggle = $productPanel.find('.select-toggle');

          var newState = state == '' ? 'selected' : '';
          if (setState) {
            newState = setState;
          }

          if (newState == 'selected') {
            $productPanel.attr('data-selected', 'selected');
            $stateToggle.addClass('selected');
          } else {
            $productPanel.attr('data-selected', '');
            $stateToggle.removeClass('selected');
          }

          self.updateRecommendedTotals();
        },

        /* Calculate cart total */
        updateRecommendedTotals: function() {
          var self = this;
          var $ = self.$;

          var subsetClasses = [ 'st-over-kit', 'st-under-kit'];

          for (var si = 0; si < subsetClasses.length; si++) {
            var subsetClass = subsetClasses[si];
            var $bundle = $('.subtype-panel.' + subsetClass + ' .product-recommend-bundle');
            var $products = $bundle.find('.recommend-product.recommended');
            var $total = $bundle.find('.recommend-product.totals');

            var totalPrice = 0;
            var numSelected = 0;
            $products.each(function() {
              var $product = $(this);
              if ($product.attr('data-selected') == 'selected') {
                totalPrice += parseFloat($product.data('price'));
                numSelected++;
              }
            });
            totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
            $total.find('.total .price').html('$' + totalPrice);

            var $totalAddToCart = $total.find('.add-to-cart .button');
            if (numSelected > 0) {
              $totalAddToCart.html('Add selected to cart').removeClass('disabled');
            } else {
              $totalAddToCart.html('No selection').addClass('disabled');
            }
          }
        },

        updateRecommendationsCartState: function() {
          var self = this;
          var $ = self.$;

          self.getCart(self.updateRecommendationsCartFetched);
        },

        updateRecommendationsCartFetched: function() {
          var self = AquaTechTheme.BuildYourSetup;
          var $ = self.$;

          var subsetClasses = [ 'st-over-kit', 'st-under-kit'];

          for (var si = 0; si < subsetClasses.length; si++) {
            var subsetClass = subsetClasses[si];
            var $bundle = $('.subtype-panel.' + subsetClass + ' .product-recommend-bundle');
            var $products = $bundle.find('.recommend-product.recommended');
            $products.each(function() {
              var $product = $(this);
              var $button = $product.find('.add-to-cart .button');
              var available = $button.parent().hasClass('out-of-stock') == false;
              if (available) {
                $button.removeClass('disabled');
                $button.html('Add to cart');
              } else {
                $button.addClass('disabled');
                $button.html('Out of stock');
              }
            });
          }

          for (var prodId in self.cachedCartProducts) {
            if (self.cachedCartProducts.hasOwnProperty(prodId)) {
              var variantId = self.cachedCartProducts[prodId].variant_id;
              var $matchRecommendation = $(".recommend-product.recommended[data-variant-id='" + variantId + "']");
              $matchRecommendation.addClass('in-cart');
              var $button = $matchRecommendation.find('.add-to-cart .button');
              $button.addClass('disabled');
              $button.html('In cart');
              $matchRecommendation.attr('data-selected', '');
              var $select = $matchRecommendation.find('.select-toggle');
              $select.removeClass('selected');
            }
          }

          self.updateRecommendedTotals();
        },

        toggleRecommendSelect: function($productPanel, setState) {
          var self = this;
          var $ = self.$;

          var state = $productPanel.attr('data-selected');
          var $stateToggle = $productPanel.find('.select-toggle');

          var newState = state == '' ? 'selected' : '';
          if (setState) {
            newState = setState;
          }

          if (newState == 'selected') {
            $productPanel.attr('data-selected', 'selected');
            $stateToggle.addClass('selected');
          } else {
            $productPanel.attr('data-selected', '');
            $stateToggle.removeClass('selected');
          }

          self.updateRecommendedTotals();
        },

        /* Ajax Fetch cart contents */
        getCart: function(callback) {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart.json",
            type: 'GET',
            success: function(response) {
              self.parseCart(response, callback);
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        /* Extract product & variant ids from cart */
        parseCart: function(response, callback) {
          var self = this;

          self.cachedCartProducts = [];

          for (var ci = 0; ci < response.items.length; ci++) {
            var item = response.items[ci];
            self.cachedCartProducts[item.product_id] = {
              variant_id: item.variant_id,
              qty: item.quantity
            }
          }

          callback();
        },

        /* Add to cart from single button click */
        addToCartSingle: function($button) {
          var self = this;
          var $ = self.$;

          var $selectedProductPanel = $button.closest('.recommend-product.recommended');
          var variantId = $selectedProductPanel.attr('data-variant-id');

          var formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };

          self.addToCartPost(formData, function() {
            self.addedSingleToCart($button);
          });
        },

        addedSingleToCart: function($addButton) {
          window.wetheme.toggleRightDrawer();
        },

        /* Add selected products in bundle to cart button click */
        addToCartSelected: function($addAllButton) {
          var self = this;
          var $ = self.$;

          var $bundle = $addAllButton.closest('.product-recommend-bundle');
          var $selectedProducts = $bundle.find(".recommend-product.recommended[data-selected='selected']");

          var items = [];
          $selectedProducts.each(function() {
            var $selectedProductPanel = $(this);
            var variantId = $selectedProductPanel.attr('data-variant-id');
            items.push({
              'id': variantId,
              'quantity': 1
            });
          });

          var formData = {
            'items': items
          };

          self.addToCartPost(formData, function() {
            self.addedSelectionToCart($addAllButton);
          });
        },

        addedSelectionToCart: function($addAllButton) {
          var self = this;

          var $totals = $('.recommend-product.totals');

          $addAllButton.html('Added to cart');

          window.wetheme.toggleRightDrawer();
        },

        toggleSelectAll: function($selectToggle) {
          var self = this;
          var $ = self.$;

          var $bundle = $selectToggle.closest('.product-recommend-bundle');
          var $productPanels = $bundle.find(".recommend-product.recommended");
          var hasSelections = false;
          var everythingSelected = true;
          $productPanels.each(function() {
              var $productPanel = $(this);
              var available = $productPanel.attr('data-available') == 'true';
              var selected = $productPanel.attr('data-selected') == 'selected';
              if (available && !selected) {
                everythingSelected = false;
              }
          });

          $productPanels.each(function() {
              var $productPanel = $(this);
              if ($productPanel.attr('data-available') == 'true') {
                if (everythingSelected) {
                  self.toggleRecommendSelect($productPanel, '');
                } else  {
                  self.toggleRecommendSelect($productPanel, 'selected');
                }
              }
          });
        },

        /* ajax POST add to cart data */
        addToCartPost: function(formData, callback) {
          var self = this;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            if (!data.status) {
              if (callback) {
                callback();
              }
              self.triggerCartUpdate();
            } else {
              console.log(data.description);
              alert(data.description);
            }
          })
          .catch((error) => {
            console.log('Error:', error);
          });
        },

        /* Watch for cart mutation: */
        watchCart: function() {
          document.documentElement.addEventListener('wetheme-cart-update', (event) => {
            console.log('Cart updated.');
            AquaTechTheme.BuildYourSetup.updateRecommendationsCartState();
          })
        },

        /* Trigger cart update event */
        triggerCartUpdate: function() {
          var self = this;
          var $ = self.$;

          $.ajax({
            url: "/cart?view=compare",
            type: 'GET',
            success: function(response) {
              var e = JSON.parse(response);
              window.wetheme.updateCartDrawer(e);
              var cartEvent = new CustomEvent("wetheme-cart-update", {
                  detail: {
                      cart: e
                  }
              });
              document.documentElement.dispatchEvent(cartEvent);

              console.log('Update Cart');
              window.THEME_CART_HOOK.fetchCart();
            },
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(xhr.status + ' ' + thrownError);
            }
          });
        },

        fetchCart: async function() {
            try {
                const languageUrl = document.getElementById("PageContainer").dataset.languageUrl;
                const e = languageUrl && "/" != languageUrl ? languageUrl : "",
                    t = await window.fetch(`${e}/cart?view=compare`);
                t.ok;
                const n = await t.json();
                this.cart = n, n.attributes.gift_note && (this.giftNote = n.attributes.gift_note), this.theme.updateCartDrawer(n)
            } catch (e) {
                console.error("Unable to fetch cart: ", e)
            }
        },

        updateUrl: function() {
          var self = this;
          var $ = self.$;

          var urlWithoutParams = window.location.origin + window.location.pathname;

          var urlParams = {
            "cbrand" : $("select[name='fit_camera_brand']").val(),
            "cmodel" : $("select[name='fit_camera_model']").val(),
            "housing" : $("select[name='sel_housing_type']").val(),
            "lmount" : $("select[name='fit_lens_mount']").val(),
            "lmodel" : $("select[name='fit_lens_model']").val(),
          };
          var urlVars = new URLSearchParams(urlParams).toString();

          window.history.pushState({ page: 1 }, "Build Your Setup", urlWithoutParams + '?' + urlVars);
        },

        applyUrl: function() {
          var self = this;
          var $ = self.$;

          var urlParams = new URLSearchParams(window.location.search);
          var selectParams = Object.fromEntries(urlParams.entries());

          // 1. Camera Brand

          if (!selectParams.cbrand) {
            return;
          }
          var $sCBrand = $("select[name='fit_camera_brand']");
          var cbrandSelection = $sCBrand.find('option[value="' + selectParams.cbrand + '"]');
          if (!cbrandSelection.length) {
            return;
          }
          $sCBrand.val(selectParams.cbrand);
          $sCBrand.trigger('change.select2');

          // 2. Camera Model

          self.populateCameraModelSelect();

          if (!selectParams.cmodel) {
            return;
          }
          var $sCModel = $("select[name='fit_camera_model']");
          var cmodelSelection = $sCModel.find('option[value="' + selectParams.cmodel + '"]');
          if (!cmodelSelection.length) {
            return;
          }
          $sCModel.val(selectParams.cmodel);
          $sCModel.trigger('change.select2');

          // 3. Housing Select

          self.populateHousingTypeSelect();

          if (!selectParams.housing) {
            return;
          }
          var $sHousing = $("select[name='sel_housing_type']");
          var housingSelection = $sHousing.find('option[value="' + selectParams.housing + '"]');
          if (!housingSelection.length) {
            return;
          }
          $sHousing.val(selectParams.housing);
          $sHousing.trigger('change.select2');

          // 4. Lens Mount

          self.populateLensMountSelect();

          if (!selectParams.lmount) {
            return;
          }
          var $sLMount = $("select[name='fit_lens_mount']");
          var lmountSelection = $sLMount.find('option[value="' + selectParams.lmount + '"]');
          if (!lmountSelection.length) {
            return;
          }
          $sLMount.val(selectParams.lmount);
          $sLMount.trigger('change.select2');

          // 5. Lens Model

          self.populateLensModelSelect();

          if (!selectParams.lmodel) {
            return;
          }
          var $sLModel = $("select[name='fit_lens_model']");
          var lmodelSelection = $sLModel.find('option[value="' + selectParams.lmodel + '"]');
          if (!lmodelSelection.length) {
            return;
          }
          $sLModel.val(selectParams.lmodel);
          $sLModel.trigger('change.select2');

          // Apply picks:

          self.onFilterStateChange();
        },

        initClipboard: function() {
            var self = this;

            if (self.clipboard) {
                self.clipboard.destroy();
            }

            self.clipboard = new ClipboardJS('.btn-clipboard');
        },

        applyCurrentSelectionBookmark: function() {
            var self = this;
            var $ = self.$;

            var $insertPoint = $("#collection-metafilters");
            var $bookmark = $insertPoint.find('.bookmark');
            if (!$bookmark.length) {
              $insertPoint.append('<span class="bookmark"></span>');
              $bookmark = $insertPoint.find('.bookmark');
            }

            var url = self.filterSelectionUrl();
            if (url) {
              $bookmark.html('<button class="btn-clipboard" data-clipboard-action="copy" data-clipboard-text="' + url + '" title="Copy selection URL to clipboard"><i class="far fa-copy"></i></button>');
              self.initClipboard();
            } else {
              $bookmark.html('...');
            }
        },

        removeBookmark: function() {
            var self = this;
            var $ = self.$;

            var $insertPoint = $("#collection-metafilters .bookmark");
            $insertPoint.remove();
        },

        filterSelectionUrl: function() {
            var self = this;
            var $ = self.$;

            var currentUrl = window.location.href;

            return currentUrl;
        }
    };

    AquaTechTheme.$(function() { AquaTechTheme.BuildYourSetup.onDocReady(); });
});
